import produce from 'immer';

import { SELECT_UNSUBSCRIPTION, RESET_UNSUBSCRIPTION, LOGOUT } from '../../constants/actionTypes';

const initState = null;

export default produce((draft, action) => {
  switch (action.type) {
    case SELECT_UNSUBSCRIPTION: {
      return action.payload;
    }

    case RESET_UNSUBSCRIPTION:
    case LOGOUT: {
      return initState;
    }
  }
}, initState);
